// header to stop api-error.interceptor.ts from automatically handling error
// can be used for situation like access data in error response in client side
export const SKIP_ERROR_INTERCEPTOR_HEADER = 'Skip-Error-Interceptor';
